/* eslint-disable */
import {
  RACButton,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTooltip,
  Typography,
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';

import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';
import {
  AddressType,
  CustomerLocationState,
  Phone,
} from '../../../types/types';
import i18n from 'i18next'; // Import i18next
import { EditContactInformationModal } from './EditContactInformationModal';
import { withContactStyles, WrappedComponentProps } from './withContactStyles';
import { abbrev, formatPhoneNumber } from '../../../utils/utils';
import clsx from 'clsx';
import { useTextConversationActions } from '../../../context/TextConversationProvider/TextConversationProvider';

const ContactInformationCustomerContent_ = ({
  classes,
  onLogClicked,
}: WrappedComponentProps) => {
  const {
    customerDetails: { phones, firstName, lastName, addresses },
    isCommunicationAllowed, countryCode, isLegalHoldProtected
  } = useCustomerDetails();
   const {enableCountryCode} = useContext(StoreStateContext);
  {console.log("PHONES",phones)}
  const location = useLocation<CustomerLocationState>();
  const { t } = useTranslation();
  const [
    showEditCustomerInformationModal,
    setShowEditCustomerInformationModal,
  ] = useState<boolean>(false);

  const [tempPhone, setTempPhone] = useState<Phone>();
  const popUpPhoneInstructions = (phone: Phone): void => {
    setTempPhone(phone);
    setShowEditCustomerInformationModal(true);
  };

  const closePhoneInstructionModal = () => {
    setShowEditCustomerInformationModal(false);
  };
  const { updatePhoneOptionsfromEdit } = useTextConversationActions();
  const updatePhoneNotes = (
    phoneId: string,
    notes: string,
    bestTimeToCall: string,
    phoneNumber: string,
    countryCodeCheck: string,
    phoneType: string,
    ext: string
  ) => {
    phones?.map((one) => {
      if (phoneId == one.phoneId) {
        one.note = notes;
        one.callTimeTypeDesc = bestTimeToCall;
        one.phoneNumber = phoneNumber;
        one.countryCode = countryCodeCheck;
        one.extension = ext;
        one.phoneTypeDesc = phoneType;
      }
    });
    if (phoneType === 'Cell Phone') {
      updatePhoneOptionsfromEdit();
    }
  };
  const renderTableHead = () => (
    <>
      <RACTableCell>{t('Name')}</RACTableCell>
      <RACTableCell>{t('Phone Number')}</RACTableCell>
      <RACTableCell>{t('Type')}</RACTableCell>
      <RACTableCell>{t('Best Time to Call')}</RACTableCell>
      <RACTableCell>{t('Phone Instructions')}</RACTableCell>
      <RACTableCell>{t('# Contacts Today')}</RACTableCell>
      <RACTableCell>{t('Last Call Result')}</RACTableCell>
      <RACTableCell align="center">{t('Action')}</RACTableCell>
    </>
  );

  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];

  const { store } = useStoreDetails()
  const storeState = store?.stateAbb?.toUpperCase();
  const countryAbb = store?.countryAbb?.toUpperCase();
  const MASSACHUSETTS = 'MA';

  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)

  const primaryAddress = addresses?.filter(
    (address) => address.addressType === AddressType.PRIMARY
  );
  const customerAddress =
    primaryAddress && primaryAddress.length > 0
      ? primaryAddress[0]
      : {
          city: '',
          state: '',
          postalCode: '',
          addressLine1: '',
          addressLine2: '',
          addressId: '',
        };
        
  const renderTableContent = () => (
    <>
      {phones?.map((phone) => (
        <RACTableRow backgroundColor="white" key={phone.phoneId}>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {`${firstName} ${lastName}`}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>            
              {formatPhoneNumber(
                phone.phoneNumber?.split('.')[0],
                isLegalHoldProtected ||
                  !isCommunicationAllowed ||
                  (customerAddress.state === MASSACHUSETTS &&
                    phone.primary !== 'Y') ||
                  (storeState === MASSACHUSETTS && phone.primary !== 'Y'),
                  enableCountryCode == 1 ? (phone.countryCode ? phone.countryCode :(regionCode[0]?.countryCodeValue ?? '')) : ''
              )}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {i18n.t(phone.phoneTypeDesc)}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {i18n.t(phone.callTimeTypeDesc)}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <RACTooltip
              placement="right-start"
              title={i18n.t(phone?.note || '')}
            >
              <Typography
                noWrap
                variant="body2"
                color="primary"
                className={clsx(phone.note)}
              >
                <span>{phone.note ? abbrev(i18n.t(phone.note)) : ''}</span>
              </Typography>
            </RACTooltip>
            <Typography noWrap variant="body2" color="primary"></Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography
              align="center"
              variant="body2"
              className={classes.tableContentColor}
            >
              {phone.communicationsToday}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <RACTooltip
              placement="right-start"
              title={i18n.t(phone.lastCallResultDescription || '')}
            >
              <Typography noWrap variant="body2" color="primary">
                <span>
                  {abbrev(i18n.t(phone.lastCallResultDescription || ''))}
                </span>
              </Typography>
            </RACTooltip>
          </RACTableCell>
          <RACTableCell className={classes.center}>
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.logButton}
              onClick={() =>
                onLogClicked(customerId, phone.phoneNumber?.split('.')[0])
              }
              disabled={
                !phone?.phoneNumber ||
                !isCommunicationAllowed ||
                isLegalHoldProtected
              }
            >
              {t('Log')}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              className={classes.editButton}
              onClick={() => popUpPhoneInstructions(phone)}
              disabled={isLegalHoldProtected}
            >
              {t('Edit')}
            </RACButton>
          </RACTableCell>
        </RACTableRow>
      ))}
    </>
  );
  return (
    <>
      <EditContactInformationModal
        open={showEditCustomerInformationModal}
        phoneId={tempPhone?.phoneId || ''}
        note={tempPhone?.note || ''}
        ext={tempPhone?.extension || ''}
        bestTimeToCall={tempPhone?.callTimeType || ''}
        active={tempPhone?.active || ''}
        primary={tempPhone?.primary || ''}
        phoneType={tempPhone?.phoneType || ''}
        phoneNumber={tempPhone?.phoneNumber || ''}
        countryCodeCheck={tempPhone?.countryCode || regionCode[0]?.countryCodeValue}
        onChange={updatePhoneNotes}
        onClose={closePhoneInstructionModal}
      />
      <RACTable
        renderTableHead={renderTableHead}
        renderTableContent={renderTableContent}
      />
    </>
  );
};

export const ContactInformationCustomerContent = (props: any) =>
  withContactStyles(props)(ContactInformationCustomerContent_);
